import React from 'react';
import Text from '../../global/text/text';
import { BLUEPRINT_SPACE_FROM_LEFT } from '../../../constants/common.constants';
import { capitalizeFirstLetter } from '../../../infrastructure/utils/string.utils';
import { connectGlobalVM } from '../../global.context';
import { ICustomComponentProps } from '../../../api/blueprints/blueprint-details.types';
import { removeNotParagraphTags } from '../../../infrastructure/utils/common.utils';

export interface IBlueprintDetailsCustomConnectionsContainerProps {
    getGroupNameById: (id: number) => string;
}

const BlueprintDetailsCustomConnectionsContainer = ({
    values,
    getGroupNameById
}: Partial<ICustomComponentProps> & IBlueprintDetailsCustomConnectionsContainerProps) => {
    return (
        <>
            {values?.map((item, index) => {
                return (
                    <div key={item.title + index} className='blueprint-details--settings-item'>
                        <Text
                            tag='div'
                            className='blueprint-details--settings-item__title'
                            message={item.title}
                        />
                        {Object.keys(item).map((key: string, i: number) => {
                            if (key === 'title' || !item[key]) return;
                            const value = key === 'group'
                                ? getGroupNameById(+item[key])
                                : item[key];

                            return (
                                <div className='blueprint-list-item' key={i}>
                                    <div className={`p-left-${BLUEPRINT_SPACE_FROM_LEFT * 2}px flex`} >
                                        <Text
                                            tag='div'
                                            className='blueprint-details--settings-item__title m-bottom-3px'
                                            message={capitalizeFirstLetter(key)}
                                        />
                                        :
                                        <Text
                                            tag='div'
                                            className='blueprint-details--settings-item__value m-left-3px word-break'
                                            message={removeNotParagraphTags(value)}
                                            setAsHtml
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            })
            }
        </>
    );
};

const BlueprintDetailsCustomConnections = connectGlobalVM<
    IBlueprintDetailsCustomConnectionsContainerProps, ICustomComponentProps
>(BlueprintDetailsCustomConnectionsContainer, vm => {
    return {
        getGroupNameById: vm.getGroupsVM().getGroupNameById
    };
});

export default BlueprintDetailsCustomConnections;
export { BlueprintDetailsCustomConnectionsContainer };
